import axios from 'axios';
import { RER_BASE_URL } from './env_variables';

// custom axios instance through-out the entire app
export const axiosInstance = axios.create({
  baseURL: RER_BASE_URL,
});
